import { jsx } from 'react/jsx-runtime';
import { IconCircle } from './Icon.Circle/Icon.Circle.es.js';
import { IconCore } from './Icon.Core/Icon.Core.es.js';
import { IconGradient } from './Icon.Gradient/Icon.Gradient.es.js';
import { SvgAppIcons } from './icons/app/index.es.js';
import { SvgBlockchainIcons } from './icons/blockchain/index.es.js';
import { SvgCommonIcons } from './icons/common/index.es.js';
import { SvgExchangeIcons } from './icons/exchange/index.es.js';
import { SvgFlagIcons } from './icons/flag/index.es.js';
import { SvgMiscellaneousIcons } from './icons/miscellaneous/index.es.js';
import { SvgPaymentIcons } from './icons/payment/index.es.js';
import { SvgSocialIcons } from './icons/social/index.es.js';
import { SvgStablecoinIcons } from './icons/stablecoin/index.es.js';
import { SvgTokenIcons } from './icons/token/index.es.js';
import { SvgWalletIcons } from './icons/wallet/index.es.js';
import { IconNameAliases } from './icons/aliases.es.js';

const IconAppList = Object.keys(SvgAppIcons);
const IconBlockchainList = Object.keys(SvgBlockchainIcons);
const IconCommonList = Object.keys(SvgCommonIcons);
const IconExchangeList = Object.keys(SvgExchangeIcons);
const IconMiscellaneousList = Object.keys(SvgMiscellaneousIcons);
const IconPaymentList = Object.keys(SvgPaymentIcons);
const IconSocialList = Object.keys(SvgSocialIcons);
const IconFlagList = Object.keys(SvgFlagIcons);
const IconStablecoinList = Object.keys(SvgStablecoinIcons);
const IconTokenList = Object.keys(SvgTokenIcons);
const IconWalletList = Object.keys(SvgWalletIcons);
const IconNameAliasesList = Object.keys(IconNameAliases);
const IconBrandList = [
    ...IconAppList,
    ...IconBlockchainList,
    ...IconExchangeList,
    ...IconMiscellaneousList,
    ...IconPaymentList,
    ...IconSocialList,
    ...IconFlagList,
    ...IconStablecoinList,
    ...IconTokenList,
    ...IconWalletList,
    ...IconNameAliasesList
];
[
    ...IconBrandList,
    ...IconCommonList
];
const Icon = (props)=>jsx(IconCore, {
        ...props
    });
Icon.displayName = 'Icon';
Icon.Circle = IconCircle;
Icon.Gradient = IconGradient;

export { Icon, IconAppList, IconBlockchainList, IconBrandList, IconCommonList, IconExchangeList, IconFlagList, IconMiscellaneousList, IconNameAliasesList, IconPaymentList, IconSocialList, IconStablecoinList, IconTokenList, IconWalletList, Icon as default };
//# sourceMappingURL=Icon.es.js.map
